import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22736e1d")

_pushScopeId("data-v-22736e1d")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = {
  key: 0,
  class: "field__err"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-attention" }),
  /*#__PURE__*/_createTextVNode(" Erreur de chargement de Google Maps ")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "field__group"
}
const _hoisted_6 = {
  key: 1,
  class: "field__item"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
const _hoisted_8 = {
  ref: "fields",
  class: "field__list"
}
const _hoisted_9 = {
  key: 0,
  class: "field__link"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-forward" }, null, -1)
const _hoisted_11 = { class: "field__title" }
const _hoisted_12 = {
  key: 1,
  class: "notes notes--error"
}
const _hoisted_13 = {
  key: 0,
  class: "icon-attention"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheFieldsUpdate = _resolveComponent("TheFieldsUpdate")
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.googleMapsErr)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_5, [
            (_ctx.canEdit)
              ? (_openBlock(), _createBlock(_component_TheFieldsUpdate, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.fieldsLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _hoisted_7
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_8, [
              (_ctx.showExternalLink)
                ? (_openBlock(), _createBlock("span", _hoisted_9, [
                    _createVNode("a", { href: _ctx.externalLink }, [
                      _createTextVNode(_toDisplayString(_ctx.externalLinkDisplayName) + " ", 1),
                      _hoisted_10
                    ], 8, ["href"])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fieldNames, (fieldName, idx) => {
                return (_openBlock(), _createBlock("div", {
                  key: idx,
                  class: "field__item"
                }, [
                  _createVNode("span", _hoisted_11, [
                    _createTextVNode(_toDisplayString(fieldName) + " ", 1),
                    (_ctx.canEdit)
                      ? (_openBlock(), _createBlock(_component_ConfirmAction, {
                          key: 0,
                          invert: true,
                          type: "delete",
                          onConfirm: ($event: any) => (_ctx.removeField(fieldName))
                        }, null, 8, ["onConfirm"]))
                      : _createCommentVNode("", true),
                    (_ctx.deleteError(fieldName))
                      ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.deleteErrorMsg(fieldName)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createVNode("div", {
                    ref: fieldName,
                    tabindex: "1",
                    class: "field__map"
                  }, null, 512), [
                    [_vShow, _ctx.validApiKeys]
                  ]),
                  (_ctx.invalidApiKeys)
                    ? (_openBlock(), _createBlock("i", _hoisted_13, "Erreur de chargement de Google Maps"))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 512)
          ]))
    ])
  ]))
})